import { IGetProduct } from './types'

export const getProductVars: IGetProduct = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
